module.exports = __webpack_public_path__ + "img/pc-hk.71ad0582.jpg";